// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__1_Hn2","loadingShrink":"PageLoading_loadingShrink__26Zve"};